import React from 'react';
import { Button, Tooltip } from 'antd';
import cn from 'classnames';
import styles from './index.module.scss';

const EditBtn = ({ className, onClick }) => {
  return (
    <Tooltip title="Изменить">
      <Button
        className={cn(styles.root, className)}
        icon="edit"
        onClick={onClick}
      />
    </Tooltip>
  );
};

export default EditBtn;
